'use client';

var calculateProfileStrength = function (profileLevel) {
    var strengthOption = [
        // { id: 0, name: 'Unfinished' },
        { id: 1, name: 'Beginner' },
        { id: 2, name: 'Intermediate' },
        { id: 3, name: 'Expert' },
        { id: 4, name: 'All Star' }
    ];
    var currentLevelPercentage = (profileLevel.level / strengthOption.length) * 100;
    var nextLevelPercentage = ((profileLevel.level + 1) / strengthOption.length) * 100;
    var percentage = currentLevelPercentage === 100
        ? 100
        : profileLevel.totalPoints > 0
            ? currentLevelPercentage +
                (profileLevel.passedPoints / profileLevel.totalPoints) *
                    (nextLevelPercentage - currentLevelPercentage)
            : 0;
    return percentage;
};

export { calculateProfileStrength };
//# sourceMappingURL=profileStrength.js.map
